<script>
import HxButtons from '@/components/buttons'
export default {
  component: {
    HxButtons,
  },
  props: {
    title: String,
    buttons: Array,
    showDownUp: Boolean,
  },
  data() {
    return {
      isUp: true,
    }
  },
  computed: {
    downUpText() {
      return this.isUp ? '折叠' : '展开'
    },
  },
  render() {
    const { title, buttons, showDownUp, downUpText } = this
    const { top } = this.$scopedSlots

    const handleDownUp = () => {
      this.isUp = !this.isUp
      this.$emit('downUp', this.isUp)
    }

    return (
      <div class="hx-title_table-pane">
        <div class="tab-top">
          <span class="table-title">
            {title}
            {showDownUp ? (
              <div onClick={handleDownUp} class="tab-left el-dropdown">
                <span
                  class="el-dropdown-link"
                  aria-haspopup="list"
                  aria-controls="dropdown-menu-2680"
                  role="button"
                  tabindex="0"
                >
                  {downUpText}
                  <i
                    class={[
                      this.isUp ? 'el-icon-arrow-up' : 'el-icon-arrow-down',
                      'el-icon--right',
                    ]}
                  ></i>
                </span>
              </div>
            ) : null}
          </span>

          <div class="tab-right">
            {top && top()}
            {this.isUp ? (
              <HxButtons type="primary" plain={true} list={buttons} />
            ) : null}
          </div>
        </div>
        {this.isUp ? this.$slots.default : null}
      </div>
    )
  },
}
</script>
